import axiosInstance from './axiosInstance';

const StripeService = {
    getProducts: () => axiosInstance.get('/api/stripe/products').then(r => r.data),
    createCheckoutSession: async (priceId) => {
        const { url } = await axiosInstance.post('/api/stripe/checkout-session', { priceId }).then(r => r.data);
        window.location.href = url;
    },
    selectFreePlan: () => axiosInstance.post('/api/stripe/free-plan').then(r => r.data),
    createBillingPortalSession: () =>
        axiosInstance.post('/api/stripe/billing-portal').then(r => r.data),
    getSubscription: () => axiosInstance.get('/api/stripe/subscription').then(r => r.data),
};

export default StripeService;
